import { useAccountAssetLifecyclePolicyFragment } from '../gql/generated/fragments';

export const useAccountAssetLifecyclePolicy = (accountId: string) => {
  const { data } = useAccountAssetLifecyclePolicyFragment(accountId);

  const defaultLifecyclePolicyDays = data?.assetLifecyclePolicy ?? null;

  return {
    defaultLifecyclePolicyDays,
    enabled: defaultLifecyclePolicyDays !== null,
  };
};
